<template>
  <question-aggregation-view-raw
    :own="own"
    :campaign="campaign"
    :data-url="dataUrl"
    :lecturer-filter="lecturerFilter"
    :course-filter="courseFilter"
    :category-filter="categoryFilter"
    :filters="filters"
    :lti="false"
    :questions="questions"
    :loading="loading"
    :has-more-data="hasMoreData"
    :loading-additional-data="loadingAdditionalData"
    @fetchData="fetchData"
    @getData="getData"
    @getAdditionalData="getAdditionalData"
    @download="download"
  >
    <template
      slot="event_link"
      slot-scope="props"
    >
      <span
        :id="'event_link_' + props.event.id + '_question_' + props.questionId"
        v-safe-html="props.event.link"
        class="hand"
        :title="props.event.date"
        data-toggle="tooltip"
      />
    </template>
  </question-aggregation-view-raw>
</template>

<script>
import axios from 'axios'
import { defaultErrorMessage } from '@/helpers'
import QuestionAggregationViewRaw from '@/shared/review/components/analytics/QuestionAggregationViewRaw'

export default {
  name: 'QuestionAggregationView',

  components: { QuestionAggregationViewRaw },

  props: {
    dataUrl: { type: String, required: true },
    filterUrl: { type: String, required: true },
    campaign: { required: false, default: null },
    own: { required: false, default: false },
  },

  data () {
    return {
      questions: [],
      filters: null,
      lecturerFilter: false,
      categoryFilter: false,
      courseFilter: false,
      loading: true,
      page: 0,
      hasMoreData: false,
      loadingAdditionalData: false,
    }
  },

  methods: {
    download (params) {
      const route = `${this.dataUrl}?export=true&course=${params.course}&lecturer=${params.lecturer}&category=${params.category}&campaign=${params.campaign}&own=${params.own}`

      window.open(route)
    },

    fetchData (params) {
      this.loading = true

      this.getData(params)

      axios.get(this.filterUrl,
        {
          params: {
            campaign: this.campaign,
            own: this.own,
          },
        }).then(({ data }) => {
        this.filters = data.data

        for (const key in this.filters) {
          if (key === 'lecturers') {
            this.lecturerFilter = true
          }

          if (key === 'courses') {
            this.courseFilter = true
          }

          if (key === 'categories') {
            this.categoryFilter = true
          }
        }

        this.loading = false
      }).catch(error => defaultErrorMessage(error))
    },

    getData (params) {
      this.loading = true

      this.page = 1
      params.page = this.page

      axios.get(this.dataUrl, {
        params,
      }).then(({ data }) => {
        this.questions = data.data
        this.hasMoreData = data.meta.hasMoreData

        this.loading = false
      }).catch(error => defaultErrorMessage(error))
    },
    getAdditionalData  (params) {
      this.loadingAdditionalData = true

      this.page += 1
      params.page = this.page

      axios.get(this.dataUrl, {
        params,
      }).then(({ data }) => {
        this.questions = this.questions.concat(data.data)
        this.hasMoreData = data.meta.hasMoreData

        this.loadingAdditionalData = false
      }).catch(error => defaultErrorMessage(error))
    },
  },
}
</script>
